import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=c65132f6&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=ts&"
export * from "./SearchResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65132f6",
  null
  
)

export default component.exports